const prod = {
  url: {
    API_URL: "https://app-api.fluxorders.com/api/",
    STORAGE_URL: "https://app-api.fluxorders.com/",
  },
};

const dev = {
  url: {
    API_URL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/",
    STORAGE_URL: process.env.REACT_APP_STORAGE_URL || "http://localhost:8000/",
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
